import {Component, Injector, Optional} from '@angular/core';

import {IWidgetConfig, Parent, provideAsWidgetRef, StylableComponent, register, styler} from '@wm/components-base';

import {WmsTranscludeDirective} from "../wms-transclude/wms-transclude.directive";

const DEFAULT_CLS = 'app-content clearfix';
const WIDGET_CONFIG: IWidgetConfig = {widgetType: 'wm-content', hostClass: DEFAULT_CLS};

@Component({
    selector: '[wmContent]',
    template: `<div class="row app-content-row clearfix" wmsTransclude>
                <ng-content></ng-content>
              </div>`,
    providers: [
      provideAsWidgetRef(ContentComponent)
    ],
    imports: [WmsTranscludeDirective],
    standalone: true
})
export class ContentComponent extends StylableComponent {
    static initializeProps = register('wm-content');

    constructor(inj: Injector, @Optional() override viewParent: Parent) {
      super(inj, WIDGET_CONFIG, viewParent);
      styler(this.nativeElement, this);
    }
}
